import { render, staticRenderFns } from "./RegisterDocumentDlg.vue?vue&type=template&id=5c301e56"
import script from "./RegisterDocumentDlg.vue?vue&type=script&lang=js"
export * from "./RegisterDocumentDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports